import axios from "axios";
import { responseError } from "./UtilService";
const api_url = process.env.REACT_APP_API_URL + "/evolucion"


export async function getEvolucion(fechaDesde = '', fechaHasta = '', marca = '' , incluyePendientes = false, montoEnDolares = false) {
    let params = "";
    if (fechaDesde) {
        params += "?fechaDesde="+fechaDesde;
    }
    if (fechaHasta) {
        params += "&fechaHasta="+fechaHasta;
    }
    if (!incluyePendientes) {
        params += "&estado=F";
    }
    if (marca) {
        params += "&marca_id="+marca;
    }
    if (montoEnDolares) {
        params += "&montoEnDolares=true";
    } else {
        params += "&montoEnDolares=false";
    }
    //console.log(api_url+params)
    try {
        let resp = await axios.get(api_url+params);
        return {
            error: false,
            data: resp.data.data
        };
    } catch(err) {
        return responseError(err, "Hubo un error al obtener datos de ventas desde el servidor.");
    }
    
}